import { ActionItem } from "@components/ActionItem";
import { Button } from "@components/Button";
import { GoalIcon } from "@components/Goals/GoalIcon";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { useAllocateFundsFlow, useModal, useUser } from "@hooks";
import { Translations, i18n } from "@i18n";
import { GenericErrorContent } from "@routes/AllocateFundsRoute/GenericErrorContent";
import { styles } from "./styles";

export const SelectGoalModal = () => {
  const { dismiss } = useModal();

  const { beneficiaries } = useUser();
  const {
    allocateFundsProps: { beneficiaryId },
    setAllocateFundsProps,
  } = useAllocateFundsFlow();

  const goals = beneficiaries?.find((b) => b?.id === beneficiaryId)?.goals;

  if (!goals?.length) {
    return <GenericErrorContent />;
  }

  return (
    <div style={styles.container}>
      {goals.map((g, index) => {
        if (!g?.name || !g.id) return null;

        return (
          <>
            <ActionItem
              key={`goal-${g.id}-${index}`}
              leftIcon={<GoalIcon type={g.type} />}
              title={g.name}
              onClick={() => {
                setAllocateFundsProps({
                  goalId: g.id,
                });
                dismiss();
              }}
            />
            <Spacing size={SpacingSizes.XS} />
          </>
        );
      })}
      <Spacing size={SpacingSizes.XS} />

      <Button title={i18n.t(Translations.SelectGoalModalPrimaryCTA)} onClick={dismiss} />
    </div>
  );
};
